import { render, staticRenderFns } from "./TAYLayout.vue?vue&type=template&id=35a9fe5f&scoped=true&"
import script from "./TAYLayout.vue?vue&type=script&lang=js&"
export * from "./TAYLayout.vue?vue&type=script&lang=js&"
import style0 from "./TAYLayout.vue?vue&type=style&index=0&id=35a9fe5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a9fe5f",
  null
  
)

export default component.exports